module.exports = __webpack_public_path__ + "static/hero2-abcbb5b4faf3a0d4f5d12a66f0c5e4ca.jpg";